import { nanoid } from '@reduxjs/toolkit';

const id = nanoid();

export default function ArrowRight({
  color = '#000000',
  className,
  ...props
}: Record<string, unknown> & { color?: string; className?: string }) {
  return (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      className={className}
      {...props}
    >
      <title>arrow-right</title>
      <defs>
        <path
          d="M10.2928932,0.292893219 C10.6834175,-0.0976310729 11.3165825,-0.0976310729 11.7071068,0.292893219 L17.7071068,6.29289322 C17.7355731,6.32135953 17.7623312,6.35153408 17.787214,6.38324992 C17.7927155,6.39015759 17.7982466,6.39739696 17.8036654,6.40469339 C17.8215099,6.42886931 17.8382813,6.45372505 17.8539326,6.47933981 C17.8613931,6.49138689 17.8685012,6.50360556 17.8753288,6.5159379 C17.8862061,6.53570605 17.8966234,6.5561086 17.9063462,6.57690085 C17.914321,6.5939015 17.9218036,6.61120435 17.9287745,6.62866398 C17.9366843,6.6484208 17.9438775,6.66820232 17.9504533,6.68826359 C17.9552713,6.70314866 17.9599023,6.71853672 17.9641549,6.73400703 C17.9701664,6.75556352 17.9753602,6.77725392 17.9798348,6.7992059 C17.9832978,6.81662474 17.9863719,6.83405099 17.9889822,6.85153313 C17.9962388,6.89963791 18,6.94937972 18,7 L17.996384,6.91477577 C17.997855,6.93207691 17.9988772,6.94940903 17.9994506,6.96675322 L18,7 C18,7.01112662 17.9998183,7.02221079 17.9994576,7.03324971 C17.9989053,7.05026637 17.9978436,7.06826549 17.9962979,7.0862308 C17.9944666,7.10788605 17.9920328,7.12852466 17.9889807,7.14896122 C17.9863719,7.16594901 17.9832978,7.18337526 17.9797599,7.20072576 C17.9753602,7.22274608 17.9701664,7.24443648 17.964279,7.26583961 C17.9599023,7.28146328 17.9552713,7.29685134 17.9502619,7.31214252 C17.9438775,7.33179768 17.9366843,7.3515792 17.928896,7.37105852 C17.9218036,7.38879565 17.914321,7.4060985 17.9063266,7.42322155 C17.8966234,7.4438914 17.8862061,7.46429395 17.8751242,7.48427695 C17.8685012,7.49639444 17.8613931,7.50861311 17.8540045,7.52070875 C17.8382813,7.54627495 17.8215099,7.57113069 17.8036865,7.5951593 C17.774687,7.63432558 17.7425008,7.67171273 17.7071068,7.70710678 L17.787214,7.61675008 C17.7849289,7.61966276 17.7826279,7.62256244 17.7803112,7.62544899 L17.7071068,7.70710678 L11.7071068,13.7071068 C11.3165825,14.0976311 10.6834175,14.0976311 10.2928932,13.7071068 C9.90236893,13.3165825 9.90236893,12.6834175 10.2928932,12.2928932 L14.585,7.999 L1,8 C0.487164161,8 0.0644928393,7.61395981 0.00672773133,7.11662113 L0,7 C0,6.44771525 0.44771525,6 1,6 L14.585,5.999 L10.2928932,1.70710678 C9.93240926,1.34662282 9.90467972,0.779391764 10.2097046,0.387100557 Z"
          id={id}
        />
      </defs>
      <g id="🕹-Icons" stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
        <g id="Feather" transform="translate(-167, -602)">
          <g id="arrow-right" transform="translate(170, 607)">
            <mask id={`mask-${id}`} fill="white">
              <use xlinkHref={`#${id}`} />
            </mask>
            <use id="Combined-Shape" fill={color} fillRule="nonzero" xlinkHref={`#${id}`} />
            <g id="🎨Color" mask={`url(#mask-${id})`} fill={color}>
              <g transform="translate(-3, -5)" id="Rectangle">
                <rect x={0} y={0} width={24} height={24} />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
